export default __webpack_public_path__ + "static/media/5.11.a957d4fc.mp3";